<template>
  <div>
    <el-dialog :visible.sync="moduleDialogVisible" title="设定功能角色" :close-on-click-modal="false" :before-close="cancel">
      <el-radio-group v-model="collectionId" v-loading="loading" v-if="functionModule.length > 0">
        <el-radio-button
          class="mb10"
          :label="item.id"
          v-for="item in functionModule"
          :key="item.id"
        >{{item.name}}</el-radio-button>
      </el-radio-group>
      <p v-else>暂无功能角色</p>
      <div class="footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="addModule">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as moduleApi from '@/api/module';
export default {
  props: {
    moduleDialogVisible: {
      required: true,
      type: Boolean
    },
    dataArr: {
      required: true
    }
  },
  data() {
    return {
      loading: false,
      collectionId: '',
      functionModule: []
    }
  },
  methods: {
    cancel() {
      this.$emit('closeDialog');
    },
    async getFunctionList() {
      this.loading = true
      let result = await moduleApi.getFunctionList()
      this.functionModule = result.data
      this.loading = false
    },
    async addModule() {
      if (this.collectionId === '') {
        this.$message({
          message: '请选择一个功能角色',
          type: 'warning'
        });
        return
      }
      let result = await moduleApi.batchModule({
        ids: this.dataArr.split(','),
        collectionId: this.collectionId
      })
      if (result.code === 200) {
        this.$message({
          message: '配置成功',
          type: 'success'
        });
        this.cancel()
        this.$parent.tableRefresh()
      }
    }
  },
  mounted() {
    this.getFunctionList()
  }
}
</script>
<style lang="scss" scoped>
.footer {
  margin-top: 20px;
  text-align: right;
}
</style>
